import api from "@/lib/api";

const CHUNK = 2 * 1024 * 1024;

// Chunked upload of one File. onProgress(0..100). Returns media doc.
export async function uploadMedia(file, { entityType, entityId, stage, caption = "" }, onProgress) {
  const { data } = await api.post("/uploads/init", {
    filename: file.name || `capture-${Date.now()}.${(file.type.split("/")[1] || "bin").split(";")[0]}`,
    content_type: file.type || "application/octet-stream", size: file.size,
    entity_type: entityType, entity_id: entityId, stage, caption,
  });
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("index", i);
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    await api.post(`/uploads/${data.upload_id}/chunk`, fd);
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const done = await api.post(`/uploads/${data.upload_id}/complete`);
  onProgress?.(100);
  return done.data;
}

export async function uploadMany(files, target, onEach) {
  const out = [];
  for (const f of files) {
    out.push(await uploadMedia(f, target, (p) => onEach?.(f, p)));
  }
  return out;
}

export const mediaUrl = (id) => `${api.defaults.baseURL}/media/${id}/file?auth=${localStorage.getItem("ro_token")}`;
